import "./blog.css";
import Header from "components/header/header";
import Loading from "components/loading/loading";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import * as blogService from "../../services/blog-service.js";
import { Slide, ToastContainer, toast } from "react-toastify";

function Blog() {
  const { blogID } = useParams();
  const [blog, setBlog] = useState();
  const [comments, setComments] = useState();
  const [isLoadingBlog, setIsLoadingBlog] = useState(true);
  const fetchBlog = async () => {
    setIsLoadingBlog(true);
    const response = await blogService.fetchBlogByID(blogID);
    setBlog(response.data);
    setIsLoadingBlog(false);
  };
  const [isLoadingComments, setIsLoadingComments] = useState(true);
  const fetchComments = async () => {
    setIsLoadingComments(true);
    const response = await blogService.fetchCommentsByBlogID(blogID);
    setComments(response.data);
    setIsLoadingComments(false);
  };
  const [post, setPost] = useState({
    name: "",
    comment: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setPost((values) => ({ ...values, [name]: value }));
  };

  const postComment = async () => {
    if (post.name.trim() !== "" && post.comment.trim() !== "") {
      const response = await blogService.postComment(blogID, post);
      document.getElementById("comment-form").reset();
      fetchComments();
    } else {
      toast("please fill out all the fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        transition: Slide,
      });
    }
  };
  useEffect(() => {
    fetchBlog();
    fetchComments();
  }, []);

  const [showForm, setShowForm] = useState(false);
  if (blog) {
    return (
      <>
        <ToastContainer />
        <Header></Header>
        <div className="page crisis-text-color">
          <div className="page-content">
            {!isLoadingBlog ? (
              <>
                <h1 className="title new-order pb-3">{blog.title}</h1>
                <div className="pb-2 open-sans">{blog.drawline}</div>
                <div className="open-sans">By {blog.author}</div>
                <div className="pb-5 open-sans"> {blog.date}</div>
                <img
                  className="pb-5 image"
                  alt=""
                  src={"../assets/blog/" + blog.image}
                />
                {blog &&
                  blog.text
                    .trim()
                    .split("\n")
                    .map((par) => <p className="paragraph open-sans">{par}</p>)}
              </>
            ) : (
              <Loading></Loading>
            )}
            <br />
            <h4 className="pb-2 bold new-order"> Comments</h4>
            <primary-button
              onClick={() => {
                setShowForm(!showForm);
              }}
            >
              {" "}
              Share your thoughts
            </primary-button>
            <br />
            {showForm ? (
              <div className="w-100 comment mt-3">
                <form id="comment-form">
                  <div className="mb-4 d-flex">
                    <h5 className="pe-2 pt-1">Name:</h5>
                    <input
                      className="form-control"
                      id="name"
                      type="name"
                      name="name"
                      placeholder="jane doe"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      name="comment"
                      id="comment"
                      placeholder="Leave your comment here..."
                      rows="2"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <primary-button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => {
                        postComment();
                      }}
                    >
                      Submit
                    </primary-button>
                  </div>
                </form>
              </div>
            ) : (
              ""
            )}
            {!isLoadingComments ? (
              <>
                {comments && comments.length > 0 ? (
                  comments.map((comment) => (
                    <div className="comment mt-3">
                      <div className="d-flex">
                        <h5 className="pe-2">Name:</h5>
                        <p>{" " + comment.name}</p>
                      </div>
                      <div>{comment.comment}</div>
                    </div>
                  ))
                ) : (
                  <div className="comment mt-3">
                    <h5>be first to leave a comment!</h5>
                  </div>
                )}
              </>
            ) : (
              <Loading></Loading>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Header></Header>
        <div className="blog-not-found mudstone-sans">Blog not found</div>
      </>
    );
  }
}

export default Blog;
